import { Model } from '../../../types'
import { SelectOption } from '../../form'

const DEFAULT_START_YEAR = 1900

export const createYearOptions = (fromYear: number, toYear: number): SelectOption[] => {
  const start = Math.min(fromYear, toYear)
  const end = Math.max(fromYear, toYear)

  return Array.from({ length: end - start + 1 }, (_, index) => {
    const year = end - index
    return { value: year.toString(), label: year.toString() }
  })
}

export const buildModelYearOptions = (
  model: Pick<Model, 'startYear' | 'endYear'> | null | undefined,
  currentYear = new Date().getFullYear(),
): SelectOption[] => {
  const startYear = model?.startYear ?? DEFAULT_START_YEAR
  const endYear = Math.min(model?.endYear ?? currentYear, currentYear)

  if (startYear > endYear) {
    return createYearOptions(endYear, endYear)
  }

  return createYearOptions(startYear, endYear)
}